import styled from "styled-components";
import PropTypes from "prop-types";

import { MediaQueries, Spacing } from "@paclife/plds.tokens";

import Typography from "common/Typography/Typography";
import BaseModal from "common/Modal/BaseModal";

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const Title = styled(Typography)`
    margin: ${Spacing[8]} 0;
    // tablet and mobile
    @media (max-width: ${MediaQueries.lg}) {
        margin: ${Spacing[8]} 0;
    }
`;

const InfoModal = ({ closeModal, title, subtitle, size }) => {
    return (
        <BaseModal 
            closeModal={closeModal}
            size={size}
        >
            <Content>
                <Title variant="h2" display="block" align="center">
                    {title}
                </Title>
                {typeof subtitle === "string" ? (
                    <Typography variant="body" align="center" display="block">
                        {subtitle}
                    </Typography>
                ) : (
                    subtitle
                )}
            </Content>
        </BaseModal>
    );
};

export default InfoModal;

InfoModal.propTypes = {
    closeModal: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired
};
